/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateExpenseTypeRequest,
  ErrorResponse,
  ExpenseType,
} from '../models/index';
import {
    CreateExpenseTypeRequestFromJSON,
    CreateExpenseTypeRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ExpenseTypeFromJSON,
    ExpenseTypeToJSON,
} from '../models/index';

export interface CreateExpenseTypeOperationRequest {
    createExpenseTypeRequest: CreateExpenseTypeRequest;
}

export interface DeleteExpenseTypeRequest {
    id: string;
}

export interface GetExpenseTypeByIdRequest {
    id: string;
}

export interface UpdateExpenseTypeRequest {
    id: string;
    createExpenseTypeRequest: CreateExpenseTypeRequest;
}

/**
 * 
 */
export class ExpenseTypesApi extends runtime.BaseAPI {

    /**
     * Create a new expense type
     * Create a new expense type
     */
    async createExpenseTypeRaw(requestParameters: CreateExpenseTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExpenseType>> {
        if (requestParameters['createExpenseTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'createExpenseTypeRequest',
                'Required parameter "createExpenseTypeRequest" was null or undefined when calling createExpenseType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/expense-types`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExpenseTypeRequestToJSON(requestParameters['createExpenseTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExpenseTypeFromJSON(jsonValue));
    }

    /**
     * Create a new expense type
     * Create a new expense type
     */
    async createExpenseType(requestParameters: CreateExpenseTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExpenseType> {
        const response = await this.createExpenseTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an expense type
     * Delete expense type
     */
    async deleteExpenseTypeRaw(requestParameters: DeleteExpenseTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteExpenseType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/expense-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an expense type
     * Delete expense type
     */
    async deleteExpenseType(requestParameters: DeleteExpenseTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExpenseTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a list of all expense types
     * Get all expense types
     */
    async getAllExpenseTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExpenseType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/expense-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExpenseTypeFromJSON));
    }

    /**
     * Retrieve a list of all expense types
     * Get all expense types
     */
    async getAllExpenseTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExpenseType>> {
        const response = await this.getAllExpenseTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an expense type by its ID
     * Get expense type by ID
     */
    async getExpenseTypeByIdRaw(requestParameters: GetExpenseTypeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExpenseType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getExpenseTypeById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/expense-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExpenseTypeFromJSON(jsonValue));
    }

    /**
     * Retrieve an expense type by its ID
     * Get expense type by ID
     */
    async getExpenseTypeById(requestParameters: GetExpenseTypeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExpenseType> {
        const response = await this.getExpenseTypeByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing expense type
     * Update expense type
     */
    async updateExpenseTypeRaw(requestParameters: UpdateExpenseTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExpenseType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateExpenseType().'
            );
        }

        if (requestParameters['createExpenseTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'createExpenseTypeRequest',
                'Required parameter "createExpenseTypeRequest" was null or undefined when calling updateExpenseType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/expense-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExpenseTypeRequestToJSON(requestParameters['createExpenseTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExpenseTypeFromJSON(jsonValue));
    }

    /**
     * Update an existing expense type
     * Update expense type
     */
    async updateExpenseType(requestParameters: UpdateExpenseTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExpenseType> {
        const response = await this.updateExpenseTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
